import React from 'react';
import { Helmet } from 'react-helmet';
import BookingSection from '../components/BookingSection';
import { Heart, Car, Sparkles, Camera, Clock } from 'lucide-react';

const ChauffeurMariageBruxelles = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Chauffeur Privé Mariage Bruxelles | Location Voiture Luxe Mariage</title>
        <meta name="description" content="Location voiture de luxe avec chauffeur pour mariage à Bruxelles. Mercedes, Lexus pour votre jour J. Service VIP, décoration incluse. Réservez maintenant." />
        <meta name="keywords" content="chauffeur mariage bruxelles, voiture mariage luxe, location voiture mariage, limousine mariage bruxelles, mercedes mariage" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/chauffeur-mariage-bruxelles" />
      </Helmet>

      <section className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <Heart className="w-16 h-16 text-gold mx-auto mb-6" />
            <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-gold via-yellow-300 to-gold bg-clip-text text-transparent">
              Chauffeur Privé pour Votre Mariage
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Voiture de luxe avec chauffeur professionnel pour votre jour J. Mercedes & Lexus décorées. 
              Service VIP pour un mariage inoubliable.
            </p>
          </div>
        </div>
      </section>

      <section id="booking" className="py-12 bg-gray-900">
        <div className="container mx-auto px-4">
          <BookingSection defaultService="chauffeur" />
        </div>
      </section>

      <section className="py-16 bg-black">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gold">
            Nos Services Mariage Premium
          </h2>
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="bg-gray-900 p-6 rounded-lg border border-gold/20">
              <Sparkles className="w-12 h-12 text-gold mb-4" />
              <h3 className="text-xl font-bold mb-3">Véhicules Décorés</h3>
              <p className="text-gray-400">
                Mercedes E-Class ou Lexus ES300h décorées avec rubans, fleurs, et accessoires personnalisés.
              </p>
            </div>
            <div className="bg-gray-900 p-6 rounded-lg border border-gold/20">
              <Car className="w-12 h-12 text-gold mb-4" />
              <h3 className="text-xl font-bold mb-3">Chauffeur en Costume</h3>
              <p className="text-gray-400">
                Chauffeur professionnel en tenue de cérémonie, discret et attentionné. Service porte-à-porte.
              </p>
            </div>
            <div className="bg-gray-900 p-6 rounded-lg border border-gold/20">
              <Camera className="w-12 h-12 text-gold mb-4" />
              <h3 className="text-xl font-bold mb-3">Photos Souvenirs</h3>
              <p className="text-gray-400">
                Moments immortalisés avec votre véhicule de luxe. Coordination avec votre photographe.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-900">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gold mb-6">Voiture de Luxe pour Votre Mariage à Bruxelles</h2>
          <p className="text-gray-300 mb-4">
            Votre mariage mérite le meilleur. Notre service de <strong>chauffeur privé pour mariage</strong> vous 
            offre des véhicules de prestige (Mercedes E-Class, Lexus ES300h) avec chauffeur en tenue de cérémonie. 
            Décoration sur mesure, champagne à bord, et service irréprochable pour votre jour J.
          </p>
          
          <h3 className="text-2xl font-bold text-gold mb-4 mt-8">Formules Mariage</h3>
          <div className="bg-gray-800 p-6 rounded-lg mb-4">
            <h4 className="text-xl font-bold text-gold mb-2">✨ Formule Classique (3h)</h4>
            <ul className="text-gray-300 space-y-2 ml-4">
              <li>• Transfert mairie → lieu de réception</li>
              <li>• Véhicule décoré + champagne</li>
              <li>• Chauffeur en costume</li>
              <li>• Disponibilité photos</li>
            </ul>
          </div>
          
          <div className="bg-gray-800 p-6 rounded-lg mb-4">
            <h4 className="text-xl font-bold text-gold mb-2">💍 Formule Premium (Journée)</h4>
            <ul className="text-gray-300 space-y-2 ml-4">
              <li>• Service complet : domicile → mairie → église → réception</li>
              <li>• 2 véhicules disponibles (mariés + invités)</li>
              <li>• Décoration haut de gamme</li>
              <li>• Bouteille de champagne premium</li>
              <li>• Coordination avec photographe</li>
            </ul>
          </div>

          <h3 className="text-2xl font-bold text-gold mb-4 mt-8">Pourquoi Nous Choisir ?</h3>
          <ul className="text-gray-300 space-y-2">
            <li>✅ <strong>Véhicules impeccables</strong> : Mercedes & Lexus récentes, parfaitement entretenues</li>
            <li>✅ <strong>Chauffeurs expérimentés</strong> : Plus de 50 mariages réalisés</li>
            <li>✅ <strong>Ponctualité absolue</strong> : Aucun retard toléré pour votre jour J</li>
            <li>✅ <strong>Décoration incluse</strong> : Rubans, fleurs, accessoires personnalisés</li>
            <li>✅ <strong>Flexibilité</strong> : Ajustement du planning le jour même si besoin</li>
          </ul>
        </div>
      </section>

      <section className="py-16 bg-gradient-to-r from-gold/10 to-gold/5">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Réservez Votre Chauffeur Mariage</h2>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            Disponibilité limitée - Réservez dès maintenant pour votre mariage.
          </p>
          <a 
            href="#booking" 
            className="inline-block bg-gold text-black px-8 py-4 rounded-lg font-bold text-lg hover:bg-gold/90 transition"
          >
            Réserver Maintenant
          </a>
        </div>
      </section>
    </div>
  );
};

export default ChauffeurMariageBruxelles;